export default "__VITE_ASSET__adac935d__"